<!-- <header>
  <nav class="navbar navbar-expand-lg justify-content-between navbar-light ">

  </nav>
</header> -->

<div class="container">
  <div class="outer-body">
    <div class="header-body">
      <p (click)="openClientTextPopup()">{{userData?.clientText}}</p>
      <select class="form-control stripe_prices" (change)="clientUrlPayment($event)">
        <option selected disabled>Stripe Payment</option>
        <option value="10">10 Slots</option>
        <option value="30">30 Slots</option>
      </select>
    </div>
    <div class="inner-body">
      <!-- <h3 class="text-left">{{userData?.userName}}</h3> -->
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">#</th>
            <!-- <th scope="col">User</th> -->
            <th scope="col">Review</th>
            <th scope="col">R</th>
            <!-- <th scope="col">R (U)</th> -->
            <th scope="col">Completed Date</th>
            <!-- <th scope="col">Review Date</th> -->
            <th class="text-center" scope="col">Image</th>
            <th class="text-center" scope="col">Approve Status</th>
            <th class="text-center" scope="col">Payment status</th>
            <th scope="col">Payment Date</th>
          </tr>
        </thead>
        <tbody *ngIf="reviewList?.length == 0 && purchasedSlots?.length == 0">
          No review found
        </tbody>
        <tbody *ngIf="reviewList?.length > 0 || purchasedSlots?.length > 0">
          <tr *ngFor="let slots of purchasedSlots; let j = index" class="table-primary">
            <th scope="row">{{reviewList?.length + purchasedSlots.length - j}}</th>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td><i class="fas fa-check-circle" style="color: green;"></i></td>
            <td>{{ slots?.created * 1000 | date : "dd/MM/yyyy" }}</td>
          </tr>
          <tr *ngFor="let review of reviewList; let i = index" [ngClass]="{'table-primary': review.is_blue_slot === 1}">
            <th class="{{review.is_circle_client == 1 ? 'numberCircle' : 'notNumberCircle'}}" scope="row"
              (click)="update_circle_client(review.id, review.manual_type)">{{reviewList.length - i}}</th>
            <!-- <td>{{review?.name}}</td> -->
            <td *ngIf="review.manual_type == 2 || review.manual_type == 3"></td>
            <td *ngIf="review.manual_type == 1">
              {{(review?.feedback_google?.description.length > 50) ? showFullDescription[i] ?
              review?.feedback_google?.description : review?.feedback_google?.description?.substring(0, 20) + '...' :
              review?.feedback_google?.description }}
              <a class="redTxt" (click)="toggleDescription(i, review)" style="color: red;">
                {{ (review?.feedback_google?.description.length > 50) && showFullDescription[i] ? 'Show Less' :
                (review?.feedback_google?.description.length > 50) ? 'Show More' : '' }}
              </a>

              {{(review?.feedback_google_two?.description.length > 50) ? showFullDescription[i] ?
              review?.feedback_google_two?.description : review?.feedback_google_two?.description?.substring(0, 20) +
              '...' : review?.feedback_google_two?.description }}
              <a class="redTxt" (click)="toggleDescription(i, review)" style="color: red;">
                {{ (review?.feedback_google_two?.description.length > 50) && showFullDescription[i] ? 'Show Less' :
                (review?.feedback_google_two?.description.length > 50) ? 'Show More' : '' }}
              </a>

              {{(review?.feedback_google_three?.description.length > 50) ? showFullDescription[i] ?
              review?.feedback_google_three?.description : review?.feedback_google_three?.description?.substring(0,
              20) + '...' : review?.feedback_google_three?.description }}
              <a class="redTxt" (click)="toggleDescription(i, review)" style="color: red;">
                {{ (review?.feedback_google_three?.description.length > 50) && showFullDescription[i] ? 'Show Less' :
                (review?.feedback_google_three?.description.length > 50) ? 'Show More' : '' }}
              </a>
            </td>
            <td>
              <!-- {{review?.feedback_google?.remarks ? review?.feedback_google?.remarks : '-'}} -->
              {{(review?.feedback_google?.client_remarks.length > 50) ? showFullClientRemarks[i] ?
              review?.feedback_google?.client_remarks : review?.feedback_google?.client_remarks?.substring(0, 20) +
              '...' : review?.feedback_google?.client_remarks }}
              <a class="redTxt" (click)="toggleClientRemarks(i, review)" style="color: red;">
                {{ (review?.feedback_google?.client_remarks.length > 50) && showFullClientRemarks[i] ? 'Show Less' :
                (review?.feedback_google?.client_remarks.length > 50) ? 'Show More' : '' }}
              </a>

              {{(review?.feedback_google_two?.client_remarks.length > 50) ? showFullClientRemarks[i] ?
              review?.feedback_google_two?.client_remarks : review?.feedback_google_two?.client_remarks?.substring(0,
              20) + '...' : review?.feedback_google_two?.client_remarks }}
              <a class="redTxt" (click)="toggleClientRemarks(i, review)" style="color: red;">
                {{ (review?.feedback_google_two?.client_remarks.length > 50) && showFullClientRemarks[i] ? 'Show Less'
                : (review?.feedback_google_two?.client_remarks.length > 50) ? 'Show More' : '' }}
              </a>

              {{(review?.feedback_google_three?.client_remarks.length > 50) ? showFullClientRemarks[i] ?
              review?.feedback_google_three?.client_remarks :
              review?.feedback_google_three?.client_remarks?.substring(0, 20) + '...' :
              review?.feedback_google_three?.client_remarks }}
              <a class="redTxt" (click)="toggleClientRemarks(i, review)" style="color: red;">
                {{ (review?.feedback_google_three?.client_remarks.length > 50) && showFullClientRemarks[i] ? 'Show
                Less' : (review?.feedback_google_three?.client_remarks.length > 50) ? 'Show More' : '' }}
              </a>
            </td>
            <!-- <td>
                            {{(review?.feedback_google?.user_remarks.length > 50) ? showFullUserRemarks[i] ? review?.feedback_google?.user_remarks : review?.feedback_google?.user_remarks?.substring(0, 20) + '...' : review?.feedback_google?.user_remarks }}
                            <a class="redTxt" (click)="toggleUserRemarks(i, review)" style="color: red;">
                                {{ (review?.feedback_google?.user_remarks.length > 50) && showFullUserRemarks[i] ? 'Show Less' : (review?.feedback_google?.user_remarks.length > 50) ? 'Show More' : '' }}
                            </a>
                          </td> -->
            <td>
              <!-- <p *ngIf="review?.feedback_google?.sms_time != 0"> -->
              <p *ngIf="review?.feedback_google">
                {{ review?.feedback_google?.sms_time * 1000 | date : "dd/MM/yyyy" }}
              </p>
              <!-- <p *ngIf="review?.feedback_google?.sms_time == 0">
                                -
                              </p> -->

              <p *ngIf="review?.feedback_google_two">
                {{ review?.feedback_google_two?.sms_time * 1000 | date : "dd/MM/yyyy" }}
              </p>
              <!-- <p *ngIf="review?.feedback_google_two?.sms_time == 0">
                                -
                              </p> -->

              <p *ngIf="review?.feedback_google_three">
                {{ review?.feedback_google_three?.sms_time * 1000 | date : "dd/MM/yyyy" }}
              </p>
              <!-- <p *ngIf="review?.feedback_google_three?.sms_time == 0">
                                -
                              </p> -->
            </td>
            <!-- <td>
                              {{ review?.updated * 1000 | date : "dd/MM/yyyy" }}
                          </td> -->
            <td class="text-center">
              <i class="fas fa-eye" (click)="viewImage(viewImageData, review)"></i>
            </td>
            <td>
              <p *ngIf="review.is_approved == 0" class="text-center">
                <i class="fas fa-check-circle"></i>
                &nbsp;
                <i class="fas fa-times-circle"></i>
              </p>
              <p *ngIf="review.is_approved == 1" class="text-center">
                <i class="fas fa-check-circle" style="color: green;"></i>
                &nbsp;
                <i class="fas fa-times-circle"></i>
              </p>
              <p *ngIf="review.is_approved == 2" class="text-center">
                <i class="fas fa-check-circle"></i>
                &nbsp;
                <i class="fas fa-times-circle" style="color: red;"></i>
              </p>
            </td>
            <td>
              <p *ngIf="review.is_client_side_paid == 0" class="text-center">
                <a title="Approve" (click)="saveFeedbackPayment(delete_form_modal, review.inboxId, 1,review, 1)">
                  <!-- <a title="Approve" (click)="saveFeedbackPayment(approve_disapprove_payment_modal, review.inboxId, 1,review, 1)"> -->
                  <!-- <a title="Approve" (click)="otp_modal(delete_form_modal, review.id, 'paymentApproved')"> -->
                  <i class="fas fa-check-circle"></i>
                </a>
                <!-- <i class="fas fa-check-circle" ></i> -->
                <!-- &nbsp;
                                  <i class="fas fa-times-circle"></i> -->
              </p>
              <p *ngIf="review.is_client_side_paid == 1" class="text-center">
                <i class="fas fa-check-circle" style="color: green;"></i>
                <!-- &nbsp;
                                  <i class="fas fa-times-circle"></i> -->
              </p>
              <p *ngIf="review.is_client_side_paid == 2" class="text-center">
                <!-- <i class="fas fa-check-circle" ></i>
                                  &nbsp; -->
                <i class="fas fa-times-circle" style="color: red;"></i>
              </p>
            </td>
            <td>
              <p *ngIf="review?.client_side_payment_time != 0">
                {{ review?.client_side_payment_time * 1000 | date : "dd/MM/yyyy" }}
              </p>
              <p *ngIf="review?.client_side_payment_time == 0">
                -
              </p>
            </td>
            <!-- <td>@mdo</td> -->
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="fixed-banner">
    <img loading="lazy" src="../../../assets/images/new/fb_bnr_web.jpg" class="audi_web">
    <img loading="lazy" src="../../../assets/images/new/fb_bnr_mob.jpg" class="audi_mob">
  </div>
</div>

<ng-template #approve_disapprove_payment_modal let-modal class="edite_modle">
  <div class="edite_modle">
    <div class="modal-header justify-content-center">
      <h4 class="modal-title">Payment Status</h4>
      <!-- <h3 class="text-center">Edit Review</h3> -->

      <a class="btn-close ml-auto" (click)="modal.dismiss('Cross click')">x</a>
      <!-- <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button> -->
    </div>
    <div class="modal-body">
      <div class="text-center">
        <h2>Are you sure want to {{is_paid_message}}</h2>
      </div>
      <div class="text-center">
        <button class="btn btn-primary mx-auto" (click)="otp_modal(delete_form_modal, gfbid, 'paymentApproved')">
          Yes
        </button> &nbsp; &nbsp;
        <button class="btn btn-primary mx-auto" (click)="modal.dismiss('Cross click')">
          No
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #delete_form_modal let-modal>
  <div id="delete_form_modal" class="login_me" role="dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <button type="button" style="outline: none;" class="close close_modal" (click)="modal.dismiss('Cross click')"
        data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span> </button>
      <div class="modal-header">
        <h5 class="modal_title_2">
          <span>Payment Approve</span>
        </h5>
      </div>
      <div class="modal-body">
        <div class=" admin_member">
          <img loading="lazy" class="modal_sm_img" src="../../../assets/images/logo.png">
          <p>Admin Password</p>

        </div>
        <form class="member_status_form">
          <div class="row">
            <div class="col-md-7 mx-auto">
              <div class="form-row">

              </div>
              <ng-container>
                <ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)"
                  [config]="{length:4,allowNumbersOnly:true,disableAutoFocus:true }"></ng-otp-input>
              </ng-container>
            </div>

            <div class="col-md-12">
              <a class="sign_in"
                (click)="saveFeedbackPayment(approve_disapprove_payment_modal, gfbid, is_client_side_paid,feedbackmessagesObj, 2)">
                Enter </a>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #viewImageData let-modal class="">
  <div class="modal-header">
    <h4 class="modal-title">View image</h4>
    <a (click)="modal.dismiss('Cross click')"><i class="fa fa-window-close" aria-hidden="true"></i></a>
  </div>
  <div class="modal-body text-center">
    <img loading="lazy" class="modal_sm_img" src="{{ imgUrl }}{{ imagepreview }}" alt="" />

  </div>
  <!-- <div class="modal-footer">
      <button
        type="button"
        class="btn btn-light"
        (click)="modal.close('Close click')"
      >
        Close
      </button>
    </div> -->
</ng-template>